import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import API from '@/lib/API';
import { Category } from '@/types';

@Module
export default class Categories extends VuexModule {
  data: Category[] = []

  get categories(): Category[] {
    return this.data;
  }

  @Mutation
  setCategories({ categories }: { categories: Category[] }) {
    console.log('mutations:setCategories'); // eslint-disable-line no-console

    const data: Category[] = [];

    categories.forEach((doc) => {
      data.push({
        id: doc.id,
        name: doc.name,
        color: doc.color,
        isActive: doc.isActive,
        hidden: doc.hidden,
        showInOperationList: doc.showInOperationList,
        showInConnectionList: doc.showInConnectionList,
      });
    });

    this.data = data;

    return Promise.resolve();
  }

  @Action({ rawError: true })
  async initCategories() {
    console.log('actions:initCategories'); // eslint-disable-line no-console

    return this.context.dispatch('updateCategories');
  }

  @Action({ rawError: true })
  async updateCategories() {
    console.log('actions:updateCategories'); // eslint-disable-line no-console

    const categories = await API.getCategories();

    if (categories instanceof Error) return Promise.reject(categories);

    return this.context.commit('setCategories', { categories });
  }
}
